export const messages = {
  en: {
    viewOwnerInfo: {
      title: 'Owner Information',
      ownerId: 'Owner ID',
      name: 'Name',
      sex: 'Gender',
      age: 'Age',
      idCard: 'ID Card',
      link: 'Contact',
      userName: 'Created By',
      remark: 'Remark',
      chooseOwner: 'Select Owner',
      loadError: 'Failed to load owner information'
    },
    showOwnerRoom: {
      info: 'Room Information',
      propertyFee: 'Property Fee',
      exitRoom: 'I want to exit the room',
      shopNum: 'Shop Number',
      roomNum: 'Room Number',
      floor: 'Floor',
      shopId: 'Shop ID',
      roomId: 'Room ID',
      builtUpArea: 'Built-up Area',
      squareMeters: 'Square Meters',
      apartmentLayout: 'Apartment Layout',
      roomCount: 'Number of Rooms',
      layer: 'layer'
    },
    ownerExitRoom: {
      confirmOperation: 'Please confirm your operation',
      confirmExit: 'Confirm to exit the room?',
      confirmExitTip: 'After exiting, it can be sold again',
      cancel: 'Cancel',
      confirmExitBtn: 'Confirm Exit'
    },
    deleteOwnerRoom: {
      page: {
        title: 'Owner Room Exit',
        subtitle: 'View owner profile and the rooms to be released'
      }
    }
  },
  zh: {
    viewOwnerInfo: {
      title: '业主信息',
      ownerId: '业主ID',
      name: '名称',
      sex: '性别',
      age: '年龄',
      idCard: '身份证',
      link: '联系方式',
      userName: '创建员工',
      remark: '备注',
      chooseOwner: '选择业主',
      loadError: '加载业主信息失败'
    },
    showOwnerRoom: {
      info: '房屋信息',
      propertyFee: '物业费',
      exitRoom: '我要退房',
      shopNum: '商铺编号',
      roomNum: '房屋编号',
      floor: '楼层',
      shopId: '商铺ID',
      roomId: '房屋ID',
      builtUpArea: '建筑面积',
      squareMeters: '平方米',
      apartmentLayout: '户型',
      roomCount: '房间数',
      layer: '层'
    },
    ownerExitRoom: {
      confirmOperation: '请确认您的操作',
      confirmExit: '确认是否退房？',
      confirmExitTip: '退房后可以再次售卖',
      cancel: '点错了',
      confirmExitBtn: '确认退出'
    },
    deleteOwnerRoom: {
      page: {
        title: '业主退房',
        subtitle: '查看业主档案与待释放房屋'
      }
    }
  }
}